import React from 'react';
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
import BreadcrumbOne from "../../elements/breadcrumb/BreadcrumbOne";
import {Link} from "react-router-dom";
import { FiArrowRight } from 'react-icons/fi';

import SectionTitle from "../../elements/sectionTitle/SectionTitle";
import TestimonialOne from "../../elements/testimonial/TestimonialOne";

const Scholarship = () => {
    return (
        <>
            <SEO title="Title" />
            <Layout>
                <BreadcrumbOne 
                    title="Scholarship Program"
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Scholarship"
                />
                <div className="main-content">

                <div class="container mt--100 mb--100">
                <div className="row row--30 align-items-center">
                    <div className="col-md-6 col-sm-12 mb--20">
                        
                            <h2 className="title">Putting Education First</h2>
                            <p>The I-94 West Chamber of Commerce is proud to once again offer a limited number of scholarships to graduating seniors in our chamber communities..</p>
                            <br/>
                            <img className="w-100" src="../images/i94-scholarship-program.jpg" alt="About Images" />
                            <p style={{"marginTop":"20px"}}><i>Special thanks to our generous business scholarship supporters! Thank you to Henningson & Snoxxell LTD., Jurrens Associates, and Thrivent - Nick Christoff, JB Group and many more for supporting local youth secondary education!</i></p>

                       </div>
                        <div class="col-md-6 col-sm-12 mb--20">
                        <h3>Eligibility</h3>
                            <p>
                                To be eligible for a scholarship, the applicant must live in or attend school in one of the following cities: Albertville, Corcoran, Dayton, Hanover, Maple Grove, Osseo, Otsego, Rogers, or St. Michael.
                                Applicants must hold a minimum GPA of 3.0 and must provide a transcript as well as three letters of recommendation from non-family members. <br/><br/>
                                Applicants must illustrate qualities of leadership, community service, and character.
                            </p>
                            <p>Additional information will be considered, including:</p>
                            <ul>
                                <li>Quality of application materials</li>
                                <li>Extracurricular activities</li>
                                <li>Leadership positions</li>
                            </ul>
                            <a href="https://forms.gle/VWynscyg3YAhjKQX7" className="btn-default btn-icon" target="_Blank">Submit Application<i className="icon"><FiArrowRight /></i></a>
                        </div>

                    {/* Scholarship Sponsors */}
                    <div className="col-12 mt--40 mb--40">
                        <SectionTitle
                            textAlign="text-center"
                            radiusRounded=""
                            subtitle="Thank You"
                            title="Our Scholarship Supporters"
                        />
                        <div className="row row--15 mt--30 justify-content-center align-items-center">
                            {[
                                { src: "/images/scholarship/henningson-snoxell.jpg", alt: "Henningson & Snoxell LTD.", url: "https://www.hennsnoxlaw.com/" },
                                { src: "/images/scholarship/jurrens-associates.jpg", alt: "Jurrens Associates", url: "https://www.jurrens.com/" },
                                { src: "/images/scholarship/thrivent-nick-christoff.jpg", alt: "Thrivent - Nick Christoff", url: "https://www.thrivent.com/" },
                                { src: "/images/scholarship/jb-group.jpg", alt: "JB Group", url: "https://www.jbgroup.com/" },
                            ].map((sponsor, index) => (
                                <div className="col-lg-3 col-md-3 col-sm-6 col-6" key={index}>
                                    <a href={sponsor.url} target="_blank" rel="noopener noreferrer">
                                        <div style={{
                                            background: "#fff",
                                            borderRadius: "10px",
                                            padding: "20px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            height: "180px",
                                            boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                                            transition: "transform 0.2s, box-shadow 0.2s",
                                            cursor: "pointer"
                                        }}>
                                            <img
                                                src={`${process.env.PUBLIC_URL}${sponsor.src}`}
                                                alt={sponsor.alt}
                                                style={{
                                                    maxWidth: "100%",
                                                    maxHeight: "140px",
                                                    objectFit: "contain"
                                                }}
                                            />
                                        </div>
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>

                          {/* Start Elements Area  */}
                    <div className="rwt-testimonial-area rn-section-gap">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 mb--10">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        subtitle = " 2025 scholarship recipients"
                                        title = "Scholarship Winners"
                                    />
                                </div>
                            </div>
                            <TestimonialOne column="col-lg-4 col-md-6 col-12 mt--30" teamStyle="card-style-default testimonial-style-one" />
                            <p style={{'textAlign':'Center'}} className="mt-5">We are inspired by their accomplishments and can’t wait to see the impact they’ll make in the years ahead. Thank you to all who contributed!</p>
                        </div>
                    </div>
                    {/* End Elements Area  */}


                    </div>
                </div>
            </div>

           
            </Layout>
        </>
    )
}
export default Scholarship;